export default __webpack_public_path__ + "static/media/IL-ROI-Logo.2f886160.svg";